import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams, useLocation } from 'react-router-dom';
import useAuth from './useAuth';
import './Manage_User.css';
import * as XLSX from 'xlsx';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import DatePicker from "react-datepicker";
import './Loader.css';
import Pagination from './Pagination.js';
import RejectedListModal from './ConveyanceRejectedList.js';
//import { BASE_URL } from "./Constants.js";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Loader = () => (
    <div className="loader-container1">
        <div className="spinner1"></div>
        <p>Loading...</p>
    </div>
);

const OwnAdvanceForm = () => {
    const { status } = useParams();
    const [showRejectedModal, setShowRejectedModal] = useState(false);
    const location = useLocation();
    const [EmpCode, setEmpCode] = useState('');
    const [RptMgr, setRptMgr] = useState('');
    const [items, setItems] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);
    const [filteredItems1, setFilteredItems1] = useState([]);
    const [selectedDept, setSelectedDept] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [showLogPopup, setShowLogPopup] = useState(false);
    const [logResponse, setLogResponse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(100);
    const [startDate, setStartDate] = useState(null);  // For date picker
    const [endDate, setEndDate] = useState(null);
    const [auditStatusFilter, setAuditStatusFilter] = useState('');
    const [sortColumn, setSortColumn] = useState('SysNo');
    const [sortOrder, setSortOrder] = useState('asc');
    const navigate = useNavigate();
    useAuth();

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                if (result.status) {
                    setEmpCode(result.profile.emp_code || '');
                    setRptMgr(result.profile.report_mngr || '');
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchProfileData();
    }, []);

    useEffect(() => {
        const fetchItems = async (EmpCode) => {
            try {
                const token = localStorage.getItem('authToken');

                if (!token || !EmpCode) return;

                const response = await fetch(`${API_BASE_URL}getLocalConveyanceam?audit_mngr=${encodeURIComponent(EmpCode)}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                if (result.status) {
                    setItems(result.conveyance_details);
                    setFilteredItems1(result.conveyance_details);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };

        if (EmpCode) {
            fetchItems(EmpCode);
        }
    }, [EmpCode, navigate]);

    useEffect(() => {
        // Retrieve the saved auditStatusFilter from localStorage if available
        const savedFilter = localStorage.getItem('auditStatusFilter');
        if (savedFilter) {
            setAuditStatusFilter(savedFilter);
        }
    }, []);

    useEffect(() => {
        const filtered = items.filter(item => {
            const nameMatch = item.comp_name ? item.comp_name.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const codeMatch = item.emp_code ? item.emp_code.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const gradeMatch = item.grade ? item.grade.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const deptNameMatch = item.dept_name ? item.dept_name.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const designationNameMatch = item.designation_name ? item.designation_name.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const mobileMatch = item.mobile ? item.mobile.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const bankNameMatch = item.bank_name ? item.bank_name.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const ifscCodeMatch = item.ifsc_code ? item.ifsc_code.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            //const reportMngrMatch = item.report_mngr ? item.report_mngr.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const locationNameMatch = item.location_name ? item.location_name.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const totalLocalConveyanceMatch = item.total_localconveyance ? item.total_localconveyance.toLowerCase().includes(searchQuery.toLowerCase()) : false;
            const createdAtMatch = item.created_at ? item.created_at.toLowerCase().includes(searchQuery.toLowerCase()) : false;

            // Date range matching logic
            const itemAuditApprovedDate = new Date(item.audit_approved_date);
            const matchesDateRange = (
                (!startDate || itemAuditApprovedDate >= new Date(startDate).setHours(0, 0, 0, 0)) &&
                (!endDate || itemAuditApprovedDate <= new Date(endDate).setHours(23, 59, 59, 999))
            );

            const matchesSearch = nameMatch || codeMatch || gradeMatch || deptNameMatch || designationNameMatch || mobileMatch || bankNameMatch || ifscCodeMatch || locationNameMatch || totalLocalConveyanceMatch || createdAtMatch;

            // Filter based on Audit Status
            const auditStatusMatch = auditStatusFilter ? item.audit_status === auditStatusFilter : true;



            // Filter based on URL path (same logic as before)
            if (location.pathname === '/audit_conveyance/all') {
                return matchesSearch && auditStatusMatch; // Show all matching items
            } else if (location.pathname === '/audit_conveyance/pending') {
                return item.audit_status === 'Pending' && matchesSearch; // Show only pending items
            } else if (location.pathname === '/audit_conveyance/approved') {
                return item.audit_status === 'Approved' && matchesSearch; // Show only approved items
            } else if (location.pathname === '/audit_conveyance/rejected') {
                return item.audit_status === 'Rejected' && matchesSearch; // Show only rejected items
            } else if (location.pathname === "/audit_conveyance") {
                return matchesSearch && auditStatusMatch && matchesDateRange;
            }
            return false; // Default case
        });



        // Sorting logic
        const sorted = filtered.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
            return 0;
        });

        setFilteredItems(sorted);
        setCurrentPage(1); // Reset to first page when items or search query changes
    }, [searchQuery, items, sortColumn, sortOrder, location.pathname, auditStatusFilter, startDate, endDate]);

    const handleAuditStatusChange = (e) => {
        const newFilter = e.target.value;
        setAuditStatusFilter(newFilter); // Set the selected audit status filter
        localStorage.setItem('auditStatusFilter', newFilter); // Save the filter in localStorage
    };

    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = (column) => {
        let sortedItems;
        if (column === 'sno') {
            // Sort by the order in which records appear, using array indices
            sortedItems = [...items].sort((a, b) => {
                const indexA = items.indexOf(a);
                const indexB = items.indexOf(b);
                return sortOrder === 'asc' ? indexA - indexB : indexB - indexA;
            });
        } else {
            // General sorting based on column value
            sortedItems = [...items].sort((a, b) => {
                if (a[column] < b[column]) return sortOrder === 'asc' ? -1 : 1;
                if (a[column] > b[column]) return sortOrder === 'asc' ? 1 : -1;
                return 0;
            });
        }

        setItems(sortedItems);
        setSortColumn(column);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    const exportToExcel = () => {
        // Use filteredItems to export all the data based on current filtering, not just the visible ones in pagination
        const filteredBranchNames = filteredItems.map(item => ({
            CompleteName: item.comp_name,
            Employeecode: item.emp_code,

            Grade: item.grade,

            ReportingManager: item.report_mngr,
            TotalKm: item.total_km,
            TotalAmount: Math.trunc(item.total_localconveyance),
            AuditApprovedAmount: Math.trunc(item.audit_approved_amount),
            EmpRqstDate: item.created_at,

            ReportingManagerStatus: item.rpt_mgr_status,
            AuditStatus: item.audit_status,
            FinanceStatus: item.accounts_status,

        }));

        const worksheet = XLSX.utils.json_to_sheet(filteredBranchNames);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Conveyance');
        XLSX.writeFile(workbook, 'Local_Conveyance_Details.xlsx');
    };


    const formatDate = (dateString) => {
        // Check if the dateString is valid or null
        if (!dateString) {
            return ''; // Return an empty string if dateString is null or invalid
        }

        const date = new Date(dateString); // Convert string to Date object

        // Ensure the date is valid
        if (isNaN(date)) {
            return ''; // Return empty if the date is invalid
        }

        const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const handleLog = async (id) => {
        try {
            const token = localStorage.getItem('authToken');

            const response = await fetch(`${API_BASE_URL}local_conveyance_log_form/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const result = await response.json();

            // Save API response
            setLogResponse(result);
            setShowLogPopup(true);

        } catch (error) {
            console.error("Error fetching log:", error);
            setLogResponse({ message: "Something went wrong!" });
            setShowLogPopup(true);
        }
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Tour/Travel - Local Conveyance</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><Link to="/dashboard">Home</Link></li>
                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Tour/Travel-Advance Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showRejectedModal && (
                        <RejectedListModal onClose={() => setShowRejectedModal(false)} />
                    )}
                    <section className="content">
                        <div className="container-fluid">

                            <div className="row">
                                <section className="col-lg-12 connectedSortable">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Audit Status Filter</label>
                                                        <select
                                                            className="form-control custom-select-sm"
                                                            value={auditStatusFilter}
                                                            onChange={handleAuditStatusChange}
                                                        >
                                                            <option value="">All</option>
                                                            <option value="Pending">Pending</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </select>
                                                    </div>

                                                </div>
                                                <div className="col-md-8 text-right">
                                                    <button type="button" className="btn btn-secondary" onClick={exportToExcel}>
                                                        Export to Excel
                                                    </button>
                                                    <button type="button" className="btn btn-danger" onClick={() => setShowRejectedModal(true)}>
                                                        View Rejected List
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {loading ? (
                                                <Loader /> // Show loader if loading is true
                                            ) : (
                                                <>
                                                    <div className="row align-items-end mb-3">
                                                        {/* Department Filter */}
                                                        <div className="col-md-2">
                                                            <label>Department</label>
                                                            <select
                                                                className="form-control"
                                                                value={selectedDept}
                                                                onChange={(e) => {
                                                                    const dept = e.target.value;
                                                                    setSelectedDept(dept);
                                                                    const filtered = dept
                                                                        ? items.filter(item => item.dept_name === dept)
                                                                        : items;
                                                                    setFilteredItems(filtered);
                                                                }}
                                                            >
                                                                <option value="">All Departments</option>
                                                                {[...new Set(items.map(item => item.dept_name))].map((dept, index) => (
                                                                    <option key={index} value={dept}>{dept}</option>
                                                                ))}
                                                            </select>
                                                        </div>



                                                        {/* Items Per Page */}
                                                        <div className="col-md-2">
                                                            <label>Items Per Page</label>
                                                            <select
                                                                className="form-control custom-select-sm"
                                                                value={itemsPerPage}
                                                                onChange={handleItemsPerPageChange}
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={50}>50</option>
                                                                <option value={100}>100</option>
                                                            </select>
                                                        </div>

                                                        {/* Start Date */}
                                                        <div className="col-md-3">
                                                            <label>Start Date</label>
                                                            <DatePicker
                                                                selected={startDate}
                                                                onChange={(date) => setStartDate(date)}
                                                                selectsStart
                                                                startDate={startDate}
                                                                endDate={endDate}
                                                                dateFormat="yyyy-MM-dd"
                                                                className="form-control"
                                                                placeholderText="Select Start Date"
                                                            />
                                                        </div>

                                                        {/* End Date */}
                                                        <div className="col-md-3">
                                                            <label>End Date</label>
                                                            <DatePicker
                                                                selected={endDate}
                                                                onChange={(date) => setEndDate(date)}
                                                                selectsEnd
                                                                startDate={startDate}
                                                                endDate={endDate}
                                                                minDate={startDate}
                                                                dateFormat="yyyy-MM-dd"
                                                                className="form-control"
                                                                placeholderText="Select End Date"
                                                            />
                                                        </div>

                                                        {/* Search Input */}
                                                        <div className="col-md-2">
                                                            <label>Search</label>
                                                            <input
                                                                type="search"
                                                                value={searchQuery}
                                                                onChange={handleSearchChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Search"
                                                                aria-controls="example1"
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped" style={{ fontSize: '13px' }}>
                                                            <thead>
                                                                <tr>
                                                                    <th onClick={() => handleSort("sno")} style={{ cursor: 'pointer', backgroundColor: sortColumn === "sno" ? '#f8f9fa' : 'transparent' }}>
                                                                        S.No {sortColumn === "sno" && (sortOrder === "asc" ? '▲' : '▼')}
                                                                    </th>
                                                                    <th>Emp Code</th>
                                                                    <th>Trans Code</th>
                                                                    <th>Emp Name</th>
                                                                    <th>Grade</th>
                                                                    <th>Travel Mode</th>
                                                                    <th>Total KM</th>
                                                                    <th>Total Amount</th>
                                                                    <th>Audit Approved Amount</th>
                                                                    <th>Reporting Manager</th>
                                                                    <th>Created at</th>
                                                                    <th>Audit Approved Date</th>
                                                                    <th>Reporting Manager Status</th>
                                                                    <th>Audit Status</th>
                                                                    <th>Finance Status</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentItems.length > 0 ? (
                                                                    currentItems.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                                                            <td>{item.emp_code}</td>
                                                                            <td>{item.trans_code}</td>
                                                                            <td>{item.comp_name}</td>
                                                                            <td>{item.grade}</td>
                                                                            <td>{item.transportMethod}</td>
                                                                            <td>
                                                                                {Math.trunc(item.total_km)}
                                                                            </td>
                                                                            <td>
                                                                                {Math.trunc(item.total_localconveyance)}
                                                                            </td>
                                                                            <td>
                                                                                {Math.trunc(item.audit_approved_amount)}
                                                                            </td>
                                                                            <td>{item.report_mngr}</td>
                                                                            <td>{formatDate(item.created_at)}</td>
                                                                            <td>{formatDate(item.audit_approved_date)}</td>

                                                                            <td style={{ color: item.rpt_mgr_status === 'Pending' ? 'orange' : item.rpt_mgr_status === 'Rejected' ? 'red' : item.rpt_mgr_status === 'Approved' ? 'green' : 'inherit' }}>
                                                                                {item.rpt_mgr_status}
                                                                            </td>
                                                                            <td style={{ color: item.audit_status === 'Pending' ? 'orange' : item.audit_status === 'Approved' ? 'green' : item.audit_status === 'Rejected' ? 'red' : 'inherit' }}>
                                                                                {item.audit_status}
                                                                            </td>
                                                                            <td style={{ color: item.accounts_status === 'Pending' ? 'orange' : item.accounts_status === 'Approved' ? 'green' : item.accounts_status === 'Rejected' ? 'red' : 'inherit' }}>
                                                                                {item.accounts_status}
                                                                            </td>
                                                                            <td>
                                                                                <Link to={`/edit_audit_local_conveyance/${item.id}`}>
                                                                                    <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green', marginRight: '10px' }}></i>
                                                                                </Link>
                                                                                {/* {item.account_status === 'Pending' && (<a href="#" onClick={(e) => handleDelete(item.id, e)}>
                                                                                                                                            <i className="fa fa-times" style={{ fontSize: '12px', color: 'red' }}></i>
                                                                                                                                        </a>)} */}
                                                                                <i
                                                                                    className="fa fa-eye"
                                                                                    onClick={() => handleLog(item.id)}
                                                                                    style={{ fontSize: '12px', color: 'green', cursor: 'pointer' }}
                                                                                ></i>
                                                                            </td>

                                                                        </tr>

                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="15" style={{ textAlign: 'center' }}>No data available</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        handlePageChange={handlePageChange}
                                    />
                                    <div className="mb-3">
                                        Showing {startItem} to {endItem} of {filteredItems.length} entries
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
                {showLogPopup && (
                    (() => {
                        const form = logResponse?.data?.form || {};
                        const details = logResponse?.data?.details || [];

                        // ✅ Helper: user value fallback to audit value
                        const getUserValue = (userVal, auditVal) =>
                            Number(userVal || 0) > 0 ? Number(userVal) : Number(auditVal || 0);

                        return (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: "100vh",
                                    backgroundColor: "rgba(0,0,0,0.4)",
                                    zIndex: 9999,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        background: "#fff",
                                        width: "90%",
                                        maxWidth: "900px",
                                        maxHeight: "90vh",
                                        overflowY: "auto",
                                        borderRadius: "10px",
                                        padding: "16px",
                                    }}
                                >
                                    {/* ================= HEADER ================= */}
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <h5>Local Conveyance – Log Details</h5>
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() => setShowLogPopup(false)}
                                        >
                                            ✕
                                        </button>
                                    </div>

                                    {/* ================= SUMMARY ================= */}
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr",
                                            gap: "16px",
                                            marginTop: "12px",
                                        }}
                                    >
                                        {/* USER CLAIMED */}
                                        <div
                                            style={{
                                                background: "#e0f2fe",
                                                padding: "10px",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <h6>💼 User Claimed</h6>
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td>Total KM</td>
                                                        <td align="right">
                                                            {getUserValue(form.total_km_user, form.total_km)}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Amount</td>
                                                        <td align="right">
                                                            ₹{" "}
                                                            {getUserValue(
                                                                form.total_localconveyance_user,
                                                                form.total_localconveyance
                                                            )}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* AUDIT APPROVED */}
                                        {form.audit_status === "Approved" ? (
                                            <div
                                                style={{
                                                    background: "#ecfdf5",
                                                    padding: "10px",
                                                    borderRadius: "8px",
                                                }}
                                            >
                                                <h6>✅ Audit Approved</h6>
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td>Total KM</td>
                                                            <td align="right">{form.total_km || 0}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total Amount</td>
                                                            <td align="right">₹ {form.total_localconveyance || 0}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div style={{ padding: "10px" }}>
                                                <h6 style={{ color: "#92400e" }}>⏳ Audit Not Approved</h6>
                                            </div>
                                        )}
                                    </div>

                                    {/* ================= ROW DETAILS ================= */}
                                    <table className="table table-bordered table-sm mt-3">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>From</th>
                                                <th>To</th>
                                                <th>User KM</th>
                                                <th>User Amount</th>
                                                {form.audit_status === "Approved" && <th>Audit KM</th>}
                                                {form.audit_status === "Approved" && <th>Audit Amount</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {details.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{row.travelDate}</td>
                                                    <td>{row.origin}</td>
                                                    <td>{row.destination}</td>

                                                    {/* USER KM (fallback to audit) */}
                                                    <td>
                                                        {getUserValue(row.distance_user, row.distance)}
                                                    </td>

                                                    {/* USER AMOUNT (fallback to audit) */}
                                                    <td>
                                                        ₹{" "}
                                                        {getUserValue(
                                                            row.travelAmount_user,
                                                            row.travelAmount
                                                        )}
                                                    </td>

                                                    {/* AUDIT COLUMNS */}
                                                    {form.audit_status === "Approved" && (
                                                        <>
                                                            <td>{row.distance || 0}</td>
                                                            <td>₹ {row.travelAmount || 0}</td>
                                                        </>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* ================= FOOTER ================= */}
                                    <div style={{ textAlign: "right" }}>
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowLogPopup(false)}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })()
                )}


                <Footer />

                <aside className="control-sidebar control-sidebar-dark">
                </aside>
            </div>
        </div>
    );
};

export default OwnAdvanceForm;
